import { IsEmail, IsEnum, IsOptional } from 'class-validator';
import { UserStatus } from '../../enums';

export class UpdateUserDto {
    @IsEmail()
    @IsOptional()
    email?: string;

    @IsEnum(UserStatus)
    @IsOptional()
    status?: UserStatus;

    @IsOptional()
    password?: string;

    @IsOptional()
    passwordResetToken?: string | null;

    @IsOptional()
    passwordResetExpires?: string | null;
}
